import React, { useState } from 'react';
import ProductCard from '../common/ProductCard';

/**
 * TrendingProducts - Trending products section with tabs
 * Follows React Rules: Uses hooks properly, pure render logic
 */
const TrendingProducts = ({
  products = {},
  onAddToCart,
  onAddToWishlist,
  onQuickView
}) => {
  const [activeTab, setActiveTab] = useState('trending');

  const tabs = [
    { id: 'trending', label: 'Trending', key: 'trending' },
    { id: 'sale', label: 'Sale', key: 'sale' },
    { id: 'new', label: 'New', key: 'new' }
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const activeTabData = tabs.find(tab => tab.id === activeTab);
  const activeProducts = activeTabData
    ? products[activeTabData.key] || []
    : [];

  if (activeProducts.length === 0) {
    return null;
  }

  return (
    <section className="product-area li-trending-product pt-60 pb-45">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="li-product-tab li-trending-product-tab">
              <ul className="nav li-product-menu">
                {tabs.map(tab => (
                  <li key={tab.id}>
                    <a
                      className={activeTab === tab.id ? 'active' : ''}
                      href={`#li-${tab.id}-product`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleTabChange(tab.id);
                      }}
                    >
                      <span>{tab.label}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="tab-content">
          {tabs.map(tab => {
            const tabProducts = products[tab.key] || [];
            if (tabProducts.length === 0) return null;
            
            return (
              <div
                key={tab.id}
                id={`li-${tab.id}-product`}
                className={`tab-pane ${activeTab === tab.id ? 'active show' : ''}`}
                role="tabpanel"
              >
                <div className="row">
                  <div className="product-active owl-carousel" data-react-carousel="true">
                    {tabProducts.map((product) => (
                      <div key={product.id} className="col-lg-12">
                        <ProductCard
                          product={product}
                          onAddToCart={onAddToCart}
                          onAddToWishlist={onAddToWishlist}
                          onQuickView={onQuickView}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrendingProducts;

